(function () {
  'use strict';

  class HomeCtrl {
    constructor() {
      this.ctrlName = 'HomeCtrl';
    }
  }

  /**
   * @ngdoc object
   * @name home.controller:HomeCtrl
   *
   * @description
   *
   */
  angular
    .module('home')
    .controller('HomeCtrl', HomeCtrl);
}());
